"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBoxSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const Rect_1 = require("./Rect");
const Text_1 = require("./Text");
exports.TextBoxSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('textbox'),
    text: Text_1.TextSchema,
    backgroundLayer: zod_1.z.number(),
    background: Rect_1.RectSchema.omit({ start: true, end: true }),
});
//# sourceMappingURL=TextBox.js.map